export const ROUTES = {
    home: "/",
    play: "/play",
    invite: "/invite",
    comingSoon: "/coming-soon",
    mining: '/mining'
}